export default {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
  },
  'es-CL': {
    currency: {
      style: 'currency',
      currency: 'CLP',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/formats/number.js